import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-boton-wsp',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './boton-wsp.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BotonWspComponent {
	@Input({ required: true }) verificador?: boolean;
	ngOnInit() {}
}
